<div
    class="tw-bg-[#0A0A75] tw-text-white tw-px-0 sm:tw-px-6 tw-pt-8 md:tw-pt-4 lg:tw-px-20 tw-flex tw-flex-col lg:tw-flex-row tw-items-center tw-justify-between tw-gap-10 lg:tw-h-[400px] tw-relative"
>
    <!-- Left Section -->
    <div *ngIf="!isDGP"
        class="tw-text-center sm:tw-text-left tw-px-6 sm:tw-px-0 tw-max-w-xl tw-relative tw-z-10"
    >
        <p
            class="tw-w-full tw-text-[32px] md:tw-text-[40px] tw-text-[#ffffff] tw-font-bold"
        >
            {{ "NEW_PRODUCTS.PRODUCTS_BANNER1.TITLE" | translate }}
        </p>
        <p class="tw-text-base md:tw-text-lg tw-mb-6">
            {{ "NEW_PRODUCTS.PRODUCTS_BANNER1.DESCRIPTION" | translate }}
        </p>
    </div>

        <div *ngIf="isDGP"
        class="tw-text-center sm:tw-text-left tw-px-6 sm:tw-px-0 tw-max-w-xl tw-relative tw-z-10"
    >
        <p
            class="tw-w-full tw-text-[32px] md:tw-text-[40px] tw-text-[#ffffff] tw-font-bold"
        >
            {{ "NEW_PRODUCTS.DGP_PRODUCTS_BANNER.TITLE" | translate }}
        </p>
        <p class="tw-text-base md:tw-text-lg tw-mb-6">
            {{ "NEW_PRODUCTS.DGP_PRODUCTS_BANNER.DESCRIPTION" | translate }}
        </p>
    </div>

    <!-- Right Section -->
    <div class="tw-w-full lg:tw-self-end lg:tw-max-w-[600px]">
        <img
            [src]="banner"
            alt="Business Financing"
            [ngClass]="{
                'tw-block sm:tw-hidden': showAlternateFinancing,
                'tw-object-contain': showBanks
            }"
            class="tw-w-full tw-h-auto tw-max-h-[350px] lg:tw-max-h-[500px]"
        />
    </div>
    <img
        *ngIf="showAlternateFinancing"
        src="/assets/images/products/dgp.webp"
        alt="Business Financing"
        class="tw-absolute tw-hidden sm:tw-block tw-top-0 tw-max-w-[770px] tw-right-0 tw-h-full"
    />
</div>
